import type { PalantirLabelColors } from '../../shared/pipes/labels/labels.type';
import type { PalantirIcon } from '../icon/icon.type';
import type { PalantirMapCenter, PalantirMapMarker } from '../map/map.type';

export interface PalantirEntityChangeLog {
  avatars: {
    icon?: PalantirIcon;
    src?: string;
  }[];
  color?: PalantirLabelColors;
  date: string;
  datetime: string;
  items?: PalantirEntityChangeLogItem[];
  title: string;
}

export type PalantirEntityChangeLogItem =
  | PalantirEntityChangeLogDiffItem
  | PalantirEntityChangeLogMapItem
  | PalantirEntityChangeLogRatingItem
  | PalantirEntityChangeLogSimpleItem;

export interface PalantirEntityChangeLogItemCommon<
  T extends PalantirEntityChangeLogItemType | PalantirEntityChangeLogItemTypeEnum,
> {
  type: T;
}

export interface PalantirEntityChangeLogSimpleItem extends PalantirEntityChangeLogItemCommon<'SIMPLE'> {
  avatar?: {
    icon?: PalantirIcon;
    src?: string;
  };
  description: string;
  title?: string;
}

export interface PalantirEntityChangeLogRatingItem extends PalantirEntityChangeLogItemCommon<'RATING'> {
  descriptionText?: string;
  descriptionTitle: string;
  rating: number;
  ratingTitle: string;
}

export interface PalantirEntityChangeLogDiffItem extends PalantirEntityChangeLogItemCommon<'DIFF'> {
  afterItems: PalantirEntityChangeLogItem[];
  afterText: string;
  beforeItems: PalantirEntityChangeLogItem[];
  beforeText: string;
}

export interface PalantirEntityChangeLogMapItem extends PalantirEntityChangeLogItemCommon<'MAP'> {
  center: PalantirMapCenter;
  key: string;
  mapId: string;
  markers?: PalantirMapMarker[];
  zoom: number;
}

export enum PalantirEntityChangeLogItemTypeEnum {
  DIFF = 'DIFF',
  MAP = 'MAP',
  RATING = 'RATING',
  SIMPLE = 'SIMPLE',
}

export type PalantirEntityChangeLogItemType = keyof typeof PalantirEntityChangeLogItemTypeEnum;
